import { setupWorker } from 'msw/browser';
import userHandlers from './handlers/userHandlers';
import authHandlers from './handlers/authHandlers';
import themeHandlers from './handlers/themeHandlers';
import appsMenuHandlers from './handlers/appsMenuHandlers';
import calendarHandlers from './handlers/calendarHandlers';
import bookingApiHandlers from './handlers/bookingApiHandlers';

const handlers = [
  ...authHandlers,
  ...userHandlers(500),
  ...themeHandlers,
  ...appsMenuHandlers,
  ...bookingApiHandlers,
  ...calendarHandlers,
];

const server = setupWorker(...handlers);

export default server;
